import _Modules from '../core/core--modules';
// import _bundle from '../core/core--bundles';
// import { _g } from '../core/core--base';
// const { _bp } = _g;

export default new _Modules({
    name: 'Module: Page Settings',
    settings: {
        block: 'body'
    },
    fn() {
        const _module = this;
        const { settings } = _module;
        const { block } = settings;

        function _getSettings(el) {
            const settingsEl = document.querySelector(el);
            return settingsEl.dataset.layout;
        }
        function _settingsStringtoObject(string) {
            const settingsArr = string.split(',');
            const arrOfObj = settingsArr.map(setting => {
                const split = setting.split(':');
                const key = split[0].trim();
                let val = split[1].trim();
                if (val === 'true') val = true;
                if (val === 'false') val = false;
                const obj = {};
                obj[key] = val;
                return obj;
            });

            return Object.assign(
                {},
                ...arrOfObj.map(s => {
                    const key = Object.keys(s)[0];
                    const val = s[key];
                    const obj = {};
                    obj[key] = val;
                    return obj;
                })
            );
        }

        const _update = settingsNew => {
            const string = Object.keys(settingsNew)
                .map(function(k, i) {
                    return `${Object.keys(settingsNew)[i]}: ${settingsNew[k]}`;
                })
                .join(', ');
            $('body').attr('data-layout', string);
        };

        const _toggleSettings = settingsStringNew => {
            const settingsStringPage = _getSettings(block);
            const sPage = _settingsStringtoObject(settingsStringPage);
            const sNew = _settingsStringtoObject(settingsStringNew);
            _update({ ...{}, ...sPage, ...sNew });
        };

        return {
            toggle(settingsStringNew) {
                return _toggleSettings(settingsStringNew);
            }
        };
    }
});
